import axios from "axios"
import React, { useEffect } from "react"
import { useParams } from "react-router"
import { useState } from "react"

const MovieDetail = () => {

    let {Id} = useParams()

    let [dataMovie, setDataMovie] = useState(null)

    useEffect (() => {
        if(Id !== undefined){
            let getMovieById = async () => {
                let res = await axios.get(`https://backendexample.sanbersy.com/api/data-movie/${Id}`)
            setDataMovie({...res.data})
            }

        getMovieById()
        }
    }, [])
    
    return (
        <>
        {dataMovie !== null && (
            <>
            <h1 style={{color: "white", fontSize: "45px", fontWeight: "bold", textAlign:"center",  marginTop: "80px"}}>{dataMovie.title}</h1>
            <br/>
            <img src={dataMovie.image_url} style={{width: "50%", height: "300px", objectFit: "cover", display:"block", marginLeft:"auto", marginRight:"auto"}}/>
            <br/>
            <h1 style={{color: "white", fontSize: "25px", fontWeight: "bold", textAlign:"center"}} >Rating: {dataMovie.rating} Bintang</h1>
            <h1 style={{color: "white", fontSize: "15px", fontWeight: "bold", textAlign:"center"}}>Year: {dataMovie.year}</h1>
            <h1 style={{color: "white", fontSize: "15px", fontWeight: "bold", textAlign:"center"}} >Genre: {dataMovie.genre}</h1>
            <h1  style={{color: "white", fontSize: "15px", fontWeight: "bold", textAlign:"center"}}>Duration: {dataMovie.duration} Minutes</h1>
            <h1 style={{color: "white", fontSize: "15px", fontWeight: "bold", textAlign:"center"}} >Review: {dataMovie.review}</h1>
            <br/>
            <h1  style={{color: "white", fontSize: "15px", fontWeight: "bold", textAlign:"center"}}>Description: <br/> {dataMovie.description}</h1>
            </>
        )}
        </>
    )
}

export default MovieDetail